import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Button from '../../components/button/Button';
import ComponentWithPopover from '../../components/componentWithPopopver/ComponentWithPopover';
import { createDataTourStep, setDataTourInteraction } from '../../utils/shared/demoModeUtils';

const getNavigationItem = (title, className, path, spanText, LinkWrapper) =>
    isEmpty(path) ? (
        <span className={className}>{title}</span>
    ) : (
        <LinkWrapper
            path={path}
            className={className}
            content={
                <>
                    {title}
                    {spanText && <span>{spanText}</span>}
                </>
            }
        />
    );

const NavigationTab = props => {
    const {
        id,
        path,
        title,
        onTabClick,
        liTagClassName,
        spanText,
        isActive,
        isDisabled,
        withPopover,
        popoverTitle,
        popoverMessage,
        popoverClassName,
        LinkWrapper,
    } = props;

    const popoverRef = React.createRef();

    const handleOnBlur = () => {
        if (popoverRef.current) popoverRef.current.hide();
    };

    const disabledButtonItem = <Button className="nav-link disabled w-100" text={title} />;
    let tabItem = disabledButtonItem;
    if (!isDisabled) {
        const className = `nav-link ${isActive ? 'active' : ''}`;
        tabItem = getNavigationItem(title, className, path, spanText, LinkWrapper);
    }

    return (
        <li
            id={id}
            data-tour-step={createDataTourStep(id)}
            data-tour-allow-interaction={setDataTourInteraction(id)}
            className={`nav-item ${liTagClassName} ${isActive ? 'active' : ''}`}
            onClick={isDisabled ? () => {} : () => onTabClick(props.id)}
            tabIndex={-1}
            onBlur={handleOnBlur}
        >
            {withPopover ? (
                <ComponentWithPopover
                    title={popoverTitle}
                    message={popoverMessage}
                    className={popoverClassName}
                    ref={popoverRef}
                >
                    {disabledButtonItem}
                </ComponentWithPopover>
            ) : (
                tabItem
            )}
        </li>
    );
};

NavigationTab.defaultProps = {
    path: {},
    title: '',
    onTabClick: () => {},
    LinkWrapper: () => {},
    liTagClassName: '',
    spanText: null,
    isActive: false,
    isDisabled: false,
    withPopover: false,
    popoverTitle: null,
    popoverMessage: null,
    popoverClassName: null,
};

NavigationTab.propTypes = {
    id: PropTypes.string.isRequired,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.string,
    onTabClick: PropTypes.func,
    LinkWrapper: PropTypes.func,
    liTagClassName: PropTypes.string,
    spanText: PropTypes.string,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    withPopover: PropTypes.bool,
    popoverTitle: PropTypes.string,
    popoverMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    popoverClassName: PropTypes.string,
};

export default NavigationTab;
